<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.notice_header_search_placeholder') ||
                  '通知单号/订单编号/客户订单编号/下单客户/终端客户/业务/跟单/品牌 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="150px" size="mini">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.notice_label_noticeOrderStatus') || '处理状态'"
            >
              <el-checkbox-group v-model="form.noticeOrderStatusList">
                <el-checkbox label="N">{{
                  $l('INDEX.notice_label_status_Pending') || '未处理'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('INDEX.notice_label_status_processed') || '已处理'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderNo') || '订单编号'"
            >
              <el-input v-model.trim="form.orderNo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_custOrderNo') || '客户订单编号'
              "
            >
              <el-input v-model.trim="form.custOrderNo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_salesPersonCode') || '业务人员'
              "
            >
              <dict-select
                v-model="form.salesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_bizPersonCode') || '跟单人员'"
            >
              <dict-select
                v-model="form.bizPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
            >
              <dict-select
                v-model="form.custCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
            >
              <dict-select
                v-model="form.endCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_brand') || '客户品牌'"
            >
              <dict-select
                v-model="form.brandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderType') || '订单类型'"
            >
              <dict-select
                v-model="form.orderType"
                url="/sys/common/dict/system"
                :body="orderTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderSource') || '订单来源'"
            >
              <dict-select
                v-model="form.orderSource"
                url="/master/common/dict/biz"
                :body="orderSourceTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_orderExecuteType') || '执行方式'
              "
            >
              <dict-select
                v-model="form.orderExecuteType"
                url="/sys/common/dict/system"
                :body="orderExecuteTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_importanceLevel') || '订单性质'
              "
            >
              <dict-select
                v-model="form.importanceLevel"
                url="/master/common/dict/biz"
                :body="importanceLevelParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_scmCode') || '执行工厂'"
            >
              <dict-select
                v-model="form.scmCode"
                size="small"
                clearable
                filterable
                :body="{}"
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderScmCode') || '名义工厂'"
            >
              <dict-select
                v-model="form.orderScmCode"
                size="small"
                clearable
                filterable
                :body="{}"
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_settlementFactory') || '结算工厂'
              "
            >
              <dict-select
                v-model="form.settlementFactory"
                size="small"
                clearable
                filterable
                :body="{}"
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_factoryPaymentTerms') ||
                  '工厂付款条件'
              "
            >
              <dict-select
                v-model="form.factoryPaymentTerms"
                clearable
                filterable
                :body="paymentTermsParams"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.notice_label_noticeOrderNo') || '订单通知书编号'
              "
            >
              <el-input v-model.trim="form.noticeOrderNo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.notice_label_noticeByName') || '通知人'"
            >
              <dict-select
                v-model="form.noticeBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.notice_label_noticeTime') || '通知时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.noticeTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="noticeTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.noticeTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="noticeTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.notice_label_executionByName') || '执行人'"
            >
              <dict-select
                v-model="form.executionBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.notice_label_executionTime') || '执行时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.executionTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="executionTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.executionTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="executionTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  noticeOrderExecuteType: 'B',
  noticeOrderStatusList: ['N', 'Y']
}
export default {
  data() {
    return {
      orderTypeParams: { dictType: 'orderType' },
      orderSourceTypeParams: { dictType: 'orderSource' },
      orderStatusParams: { dictType: 'orderStatus' },
      paymentTermsParams: { dictType: 'paymentTerms' },
      orderExecuteTypeParams: { dictType: 'orderExecuteType' },
      importanceLevelParams: { dictType: 'importanceLevel' },
      advqueryDialogVisible: false,
      form: { ...initForm },

      //通知日期限制
      noticeTimeStartPicker: this.noticeTimeEnd(),
      noticeTimeEndPicker: this.noticeTimeStart(),
      //执行日期限制
      executionTimeStartPicker: this.executionTimeEnd(),
      executionTimeEndPicker: this.executionTimeStart()
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 通知时间限制
    noticeTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.noticeTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.noticeTimeEnd).getTime() < time.getTime()
          }
        }
      }
    },
    noticeTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.noticeTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.noticeTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        }
      }
    },
    //执行日期限制
    executionTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.executionTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.executionTimeEnd).getTime() < time.getTime()
            )
          }
        }
      }
    },
    executionTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.executionTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.executionTimeStart).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
